var DP = require("../DataProcessor/DataProcessor");
var DT = require("../DataTable/DataTable");
var DG = require("../DataGraph/DataGraph");

var metaKeyAttrKey = 'data-meta';
var dataKeyAttrKey = 'data-data';

var dataProcessorActivator = function() {
  $('.agen-graphs').each(function(dataEntryElementIndex, dataEntryElement) {
    //console.log('HTML Item: ', dataEntryElement);

    var metaKey = $(dataEntryElement).attr(metaKeyAttrKey);
    var dataKey = $(dataEntryElement).attr(dataKeyAttrKey);

    var data = window[dataKey];
    var meta = window[metaKey];

    //console.log("Keys: ", metaKey, dataKey, meta, data);

    var processedDataInfo = DP.proces(meta, data);
    //console.log("Processed data: ", processedDataInfo);

    var graphElement = $(dataEntryElement).find('.agen-data-graph');
    var tableElement = $(dataEntryElement).find('.agen-data-table');

    //console.log("Elements: ", graphElement, tableElement);
    DG.render(graphElement, processedDataInfo.type, processedDataInfo.graphStructure, processedDataInfo.graphData)
    DT.render(tableElement, processedDataInfo.type, processedDataInfo.tableStructure, processedDataInfo.tableData);
  });
}

$(document).ready(function() {
    dataProcessorActivator();
});

module.exports = dataProcessorActivator;



//////////////////
// WEBPACK FOOTER
// ./src/modules/DataProcessorActivator/DataProcessorActivator.js
// module id = 18
// module chunks = 0